<template>
  <v-dialog
    v-model="open"
    width="700"
  >
    <v-card>
      <v-card-title
        class="headline teal"
        primary-title
      >
        Add user to your account
      </v-card-title>
      <v-card-text>
        <p class="my-2"><b>Fill this form to add a user to your account</b></p>

        <v-form v-model="isValid">
          <v-row>
            <v-col cols="6">
              <v-text-field v-model="user.name" label="name" required :rules="rules.name"></v-text-field>
            </v-col>
            <v-col cols="6">
              <h4>Role</h4>
              <v-chip-group active-class="primary--text" v-model="user.role" mandatory required>
                <v-chip value="admin">Admin</v-chip>
                <v-chip value="user">User</v-chip>
              </v-chip-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field v-model="user.email" label="email" required :rules="rules.email"></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="user.password" label="password" required :rules="rules.password"
                            hint="Your colleague will be able to change it afterwards"
                            :persistent-hint="true"></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" text :disabled="!isValid" @click="submit()">
          Confirm
        </v-btn>
        <v-btn color="default" text @click="cancel()">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-overlay :value="submitting" :absolute="true">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
  import {nonEmptyField, validEmail, validPassword} from '../../../helpers/helpers';

  export default {
    name: "addUserToClientDialog",
    props: ['userData', 'successCallback'],
    data: () => ({
      open: false,
      isValid: false,
      submitting: false,
      user: {
        name: '',
        email: '',
        password: '',
        role: 'user'
      },
      rules: {
        name: [v => nonEmptyField(v, 'name')],
        email: [v => nonEmptyField(v, 'email'), v => validEmail(v)],
        password: [v => nonEmptyField(v, 'password'), v => validPassword(v)],
      }
    }),
    methods: {
      cancel() {
        this.open = false;
      },
      submit() {
        this.submitting = true;
        let payload = {
          clientId: this.userData.clientId,
          user: this.user,
        }
        this.$store.dispatch('addUserToClient', payload)
        .then(success => {
          this.submitting = false;
          this.$emit('successCallback', true);
          this.cancel();
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dialogs/Settings/addUserToClientDialog.vue